window.addEventListener('DOMContentLoaded', () => {
  const sMenu = document.getElementsByClassName('s-menu-pc')[0]
  const sMenuSp = document.getElementsByClassName('s-menu-sp')[0]
  const MenuItem = document.getElementsByClassName('s-menu')
  const height = window.innerHeight
  let position = 0
  let lastPosition = 0

  const onScroll = () => {
    if(sMenu) {
      if(position > height) {
        sMenu.classList.add('s-menu-pc-fixed')
      }

      if(position < height) {
        sMenu.classList.remove('s-menu-pc-fixed')
      }
    }

    if(sMenuSp) {
      if(position > 80) {
        sMenuSp.classList.add('sp-menu-fixed')
        sMenuSp.classList.remove('sp-menu-hide')
      }
      if(position < 80) {
        sMenuSp.classList.remove('sp-menu-fixed')
        sMenuSp.classList.add('sp-menu-hide')
      }

      if(position < height || position < lastPosition) {
        sMenuSp.classList.add('-moveY0px')
      }
    }
    lastPosition = position
  }

  window.addEventListener("scroll", () => {
    position = window.scrollY
    onScroll()
  })

  if (MenuItem.length > 0) {
    const lastMenuItem = MenuItem[MenuItem.length - 1];
    lastMenuItem.classList.remove('-border'); 
  }


  const DISP_COUNT = 4
  const product = document.getElementsByClassName("advantage-list item")
  const advantage = document.getElementsByClassName("advantage-list point")

  // 強み
  const header_pc_advantage_tab = document.getElementsByClassName("header-pc__advantage-tab")[0]
  const advantageSubMenu = document.getElementsByClassName("advantage-submenu")[0]

  const advantageMouseOver = () => {
    document.getElementsByClassName("-advantage-noactive").length != 0 ? advantageDisplayList() : advantageHideList();
  }

  const advantageDisplayList = () => {
    Array.from(document.getElementsByClassName("-advantage-noactive")).forEach(element => element.classList.remove("-advantage-noactive"));
    const x = advantageSubMenu.getBoundingClientRect().x
    advantageSubMenu.style.left = `-${x}px`
  }

  const advantageHideList = () => {
    if (advantageSubMenu) {
      advantageSubMenu.classList.add("-advantage-noactive");
    }
    header_pc_advantage_tab.classList.add("-advantage-noactive");
  }

  if (header_pc_advantage_tab) {
    header_pc_advantage_tab.addEventListener('mouseover', () => {
      advantageMouseOver();
      if (product.length >= DISP_COUNT) {
        document.getElementsByClassName("submenu-pc__advantage-list item")[0].classList.add("-wrap");
      }
      if (advantage.length >= DISP_COUNT) {
        document.getElementsByClassName("submenu-pc__advantage-list point")[0].classList.add("-wrap");
      }
    });

    header_pc_advantage_tab.addEventListener('mouseout', () => {
      if(advantageSubMenu) {
        advantageSubMenu.style.left = ''
        advantageSubMenu.style.width = ''
        advantageSubMenu.classList.add("-advantage-noactive");
      }
    });
  }

  // 商品
  const header_pc_product_tab = document.getElementsByClassName("header-pc__product-tab")[0]
  const productSubMenu = document.getElementsByClassName("product-submenu")[0]

  const productMouseOver = () => {
    document.getElementsByClassName("-product-noactive").length != 0 ? productDisplayList() : productHideList();
  }

  const productDisplayList = () => {
    Array.from(document.getElementsByClassName("-product-noactive")).forEach(element => element.classList.remove("-product-noactive"));
    const x = productSubMenu.getBoundingClientRect().x
    productSubMenu.style.left = `-${x}px`
  }

  const productHideList = () => {
    if (productSubMenu) {
      productSubMenu.classList.add("-product-noactive");
    }
    header_pc_advantage_tab.classList.add("-product-noactive");
  }

  if (header_pc_product_tab) {
    header_pc_product_tab.addEventListener('mouseover', () => {
      productMouseOver();
      if (product.length >= DISP_COUNT) {
        document.getElementsByClassName("submenu-pc__advantage-list item")[0].classList.add("-wrap");
      }
      if (advantage.length >= DISP_COUNT) {
        document.getElementsByClassName("submenu-pc__advantage-list point")[0].classList.add("-wrap");
      }
    });

    header_pc_product_tab.addEventListener('mouseout', () => {
      if(productSubMenu) {
        productSubMenu.style.left = ''
        productSubMenu.style.width = ''
        productSubMenu.classList.add("-product-noactive");
      }
    });
  }
})
